"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPStatusCode = void 0;
exports.HTTPStatusCodeFromJSON = HTTPStatusCodeFromJSON;
exports.HTTPStatusCodeFromJSONTyped = HTTPStatusCodeFromJSONTyped;
exports.HTTPStatusCodeToJSON = HTTPStatusCodeToJSON;
exports.HTTPStatusCodeToJSONTyped = HTTPStatusCodeToJSONTyped;
/**
 * HTTP Status Code
 * @export
 * @enum {string}
 */
var HTTPStatusCode;
(function (HTTPStatusCode) {
    HTTPStatusCode[HTTPStatusCode["NUMBER_200"] = 200] = "NUMBER_200";
    HTTPStatusCode[HTTPStatusCode["NUMBER_302"] = 302] = "NUMBER_302";
    HTTPStatusCode[HTTPStatusCode["NUMBER_307"] = 307] = "NUMBER_307";
    HTTPStatusCode[HTTPStatusCode["NUMBER_404"] = 404] = "NUMBER_404";
    HTTPStatusCode[HTTPStatusCode["NUMBER_500"] = 500] = "NUMBER_500";
})(HTTPStatusCode || (exports.HTTPStatusCode = HTTPStatusCode = {}));
function HTTPStatusCodeFromJSON(json) {
    return HTTPStatusCodeFromJSONTyped(json, false);
}
function HTTPStatusCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function HTTPStatusCodeToJSON(value) {
    return HTTPStatusCodeToJSONTyped(value, false);
}
function HTTPStatusCodeToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
